import * as React from 'react';

type CarouselContextValue = {
  index: number;
  slideCount: number;
  canGoPrevious: boolean;
  canGoNext: boolean;
  loop: boolean;
  setIndex: (index: number) => void;
  goToPrevious: () => void;
  goToNext: () => void;
  registerSlide: () => () => void;
};

export const CarouselContext = React.createContext<CarouselContextValue | null>(null);

export function useCarouselContext(componentName: string) {
  const context = React.useContext(CarouselContext);

  if (!context) {
    throw new Error(`${componentName} must be used within CarouselRoot`);
  }

  return context;
}
